const useUpdateWarning = (meta: ComputedRef<FormMeta>, isSubmitting: Ref<boolean>) => {
  const toRoute = ref<null | RouteLocationRaw>(null);
  const leaved = ref(false);
  const { closeModal, openModal } = useModalStore();

  const navigateToRoute = async () => {
    if (toRoute.value === null) {
      return;
    }

    leaved.value = true;
    closeModal();
    await navigateTo(toRoute.value);
  };

  const blockRoute = (to: RouteLocationRaw) => {
    if (meta.value.dirty && meta.value.touched && !isSubmitting.value && !leaved.value) {
      openModal(SHARED_MODAL.UpdateWarning);
      toRoute.value = to;

      return false;
    }

    return true;
  };

  onBeforeRouteLeave((to) => {
    return blockRoute(to);
  });

  onBeforeRouteUpdate((to) => {
    return blockRoute(to);
  });

  return {
    navigateToRoute,
  };
};

export { useUpdateWarning };
